import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { Brc20Chains, Brc20Tokens } from 'data/brc20';
import { getGasUsdList, getSupportAssets, getSupportChains } from 'services/thunkServices';
import { ChaingeChain, ChaingeTokenChain, GasUsd } from 'types/baseType';
import { Chain } from 'viem';

interface Props {
  // 根据token获得链的列表
  chainsForTokenFrom: ChaingeChain[]
  chainsForTokenTo: ChaingeChain[]

  // 包含了拥有该token的链
  tokenChainsFrom: ChaingeTokenChain | undefined
  tokenChainsTo: ChaingeTokenChain | undefined

  // 完整资产
  chains: ChaingeChain[]
  tokens: ChaingeTokenChain[]

  // wagmi 的链
  wagmiChains: Chain[]

  openToAddressWin: boolean,
  openSlippageWin: boolean,
  openNewTicketWin: boolean,
  openBestDealWin: boolean,
  openDaoStakWin: boolean,

  loading: boolean,
  refreshData: number,

  // gasUsd
  gasUsdList: GasUsd[],

  brc20: boolean,
  tokensByBrc20: ChaingeTokenChain[],
  chainsByBrc20: ChaingeChain[]
}

export const appSlice = createSlice({
  name: 'app',
  initialState: {
    chainsForTokenFrom: [],
    chainsForTokenTo: [],

    tokenChainsFrom: undefined,
    tokenChainsTo: undefined,

    chains: [],
    tokens: [],

    wagmiChains: [],

    openToAddressWin: false,
    openSlippageWin: false,
    openNewTicketWin: false,
    openBestDealWin: false,
    openDaoStakWin: false,

    loading: false,
    refreshData: 0,

    gasUsdList: [],

    brc20: false,
    tokensByBrc20: Brc20Tokens,
    chainsByBrc20: Brc20Chains
  } as Props,
  reducers: {
    setChainsForTokenFrom: (state, { payload } : PayloadAction<ChaingeChain[]>) => {
      state.chainsForTokenFrom = payload
    },
    setChainsForTokenTo: (state, { payload } : PayloadAction<ChaingeChain[]>) => {
      state.chainsForTokenTo = payload
    },

    setTokenChainsFrom: (state, { payload } : PayloadAction<ChaingeTokenChain | undefined>) => {
      state.tokenChainsFrom = payload
    },
    setTokenChainsTo: (state, { payload } : PayloadAction<ChaingeTokenChain | undefined>) => {
      state.tokenChainsTo = payload
    },

    setOpenToAddressWin: (state, { payload } : PayloadAction<boolean>) => {
      state.openToAddressWin = payload
    },
    setOpenNewTicketWin: (state, { payload } : PayloadAction<boolean>) => {
      state.openNewTicketWin = payload
    },

    setLoading: (state, { payload } : PayloadAction<boolean>) => {
      state.loading = payload
    },

    setRefreshData: (state, { payload } : PayloadAction<number>) => {
      state.refreshData = payload
    },
    setOpenSlippageWin: (state, { payload } : PayloadAction<boolean>) => {
      state.openSlippageWin = payload
    },
    setOpenBestDealWin: (state, { payload } : PayloadAction<boolean>) => {
      state.openBestDealWin = payload
    },
    setOpenDaoStakWin: (state, { payload } : PayloadAction<boolean>) => {
      state.openDaoStakWin = payload
    },
    setGasUsdList: (state, { payload } : PayloadAction<GasUsd[]>) => {
      state.gasUsdList = payload
    },
    setBrc20: (state, { payload } : PayloadAction<boolean>) => {
      state.brc20 = payload
    },
  },
  extraReducers(builder) {
    builder.addCase(getSupportChains.fulfilled, (state, { payload } : PayloadAction<{chains: ChaingeChain[], wagmiChains: any} | ''>) => {
      if(payload) {
        state.chains = payload.chains
        state.wagmiChains = payload.wagmiChains
      } else{
        state.chains = []
        state.wagmiChains = []
      }
    });
    builder.addCase(getSupportAssets.fulfilled, (state, { payload }) => {
      if(payload) {
         state.tokens = payload
      } else {
        state.tokens = []
      }
    });
    builder.addCase(getGasUsdList.fulfilled, (state, { payload }) => {
      if(payload) {
         state.gasUsdList = payload
      } else {
        state.tokens = []
      }
    });
  }
})

// Action creators are generated for each case reducer function
export const { setChainsForTokenFrom, setChainsForTokenTo, setOpenToAddressWin, setTokenChainsFrom, setTokenChainsTo, setLoading, setRefreshData, setOpenSlippageWin, setGasUsdList, setOpenNewTicketWin, setOpenBestDealWin, setBrc20, setOpenDaoStakWin } = appSlice.actions

export default appSlice.reducer
